/**
 * Decodes a JWT payload without verifying the signature.
 * Handles base64url encoding (no padding, URL-safe chars).
 */
export const decodeJwtPayload = (token) => {
  try {
    if (!token) return null;
    const parts = token.split('.');
    if (parts.length !== 3) return null;

    let base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padLength = (4 - (base64.length % 4)) % 4;
    base64 += '='.repeat(padLength);

    const decoded = atob(base64);
    return JSON.parse(decoded);
  } catch {
    return null;
  }
};
